import { QueryClient } from '@tanstack/react-query';

import { feedbackMutationCache } from './feedback';

/**
 * Mutations never auto-retry: a retried mutate() call would need to reuse the
 * same Idempotency-Key (see api/idempotency.ts) and React Query's default
 * retry re-runs mutationFn from scratch, which our idempotency holders don't
 * assume. Queries keep the default retry behavior.
 */
export const queryClient = new QueryClient({
  mutationCache: feedbackMutationCache(),
  defaultOptions: {
    mutations: { retry: false },
  },
});
